(function ($) {

    $(document).on( 'click', '#menu-toggler', function() {

        if($(this).hasClass('open')){
            $(this).removeClass('open');
            $('html').removeClass('noscroll');
            $('#primary-nav').removeClass('visible');
        } else {
            $(this).addClass('open');
            $('html').addClass('noscroll');
            $('#primary-nav').addClass('visible');
        }

    });


})
(jQuery);